import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { getPayload } from "actions"
import { connect } from "react-redux"
import Title from "containers/general/title"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import { HorizontalBar } from "react-chartjs-2"
import GroupedBar from "components/GroupedBar"
import StackedHorizontalBar from "components/StackedHorizontalBar"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

let limit = 15

class Competition extends Component {
	constructor(props) {
		super(props)
		this.state = {
			columns: {
				builderActivity: [
					{
						Header: "Builder",
						accessor: "builder",
						filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
					},
					{
						Header: "Lot Type",
						accessor: "lot_type",
						filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
					},
					{
						Header: "Gross Sales",
						accessor: "sales",
						filterable: false,
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.sales
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Cancels",
						accessor: "cancels",
						filterable: false,
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.cancels
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Closings",
						accessor: "closings",
						filterable: false,
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.closings
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
				],
			},
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.activeProperties !== prevProps.activeProperties) {
			this.props.getPayload()
		}
	}

	builderSales = () => {
		var dataArray = {}
		let model = {}
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!builder) {
				return
			}
			const builderName = helpers.safeBuilderName(builder.name)
			if (!model.hasOwnProperty(builderName)) {
				model[builderName] = 0
			}
		})
		_.forEach(this.props.payload.salespersonPayload.competition.cancels, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!builder) {
				return
			}
			const builderName = helpers.safeBuilderName(builder.name)
			if (!model.hasOwnProperty(builderName)) {
				model[builderName] = 0
			}
		})
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (!v.builder) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!type || !v.builder) {
				return
			}
			const builderName = helpers.safeBuilderName(builder.name)
			let path = `${type.name}.${builderName}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][builderName]++
			} else {
				dataArray[type.name] = _.cloneDeep(model)
				dataArray[type.name][builderName]++
			}
		})
		_.forEach(this.props.payload.salespersonPayload.competition.cancels, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (!v.builder) {
				return
			}
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (!type || !v.builder) {
				return
			}
			const builderName = helpers.safeBuilderName(builder.name)
			let path = `${type.name}.${builderName}`
			if (_.has(dataArray, path)) {
				dataArray[type.name][builderName]--
			} else {
				dataArray[type.name] = _.cloneDeep(model)
				dataArray[type.name][builderName]--
			}
		})
		// Create series
		let series = []
		_.forEach(dataArray, (v, k) => {
			series.push({
				name: k,
				data: Object.values(v),
			})
		})
		series = _.sortBy(series, "name")
		return <StackedHorizontalBar series={series} categories={Object.keys(model)} />
	}

	salesBySalespeople = () => {
		let limit = 20
		var [dataArray, labels, sorted, labelSalespeople, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]++
			} else {
				dataArray[v.salesperson] = 1
			}
		})
		_.forEach(this.props.payload.salespersonPayload.competition.cancels, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]--
			} else {
				dataArray[v.salesperson] = -1
			}
		})

		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}
		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelSalespeople.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelSalespeople, (v) => {
			let sp = _.find(this.props.payload.public.salespeople, {
				id: parseInt(v),
			})
			if (sp) {
				labels.push(`${sp.first} ${sp.last}`)
			}
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	buildTable = () => {
		var ret = []
		let store = {}
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			let path = `${v.builder}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(
					store,
					path,
					{
						sales: 0,
						cancels: 0,
						closings: 0,
					},
					Object
				)
			}
			//console.log(v, store)
			store[v.builder][v.lot_type].sales++
		})
		_.forEach(this.props.payload.salespersonPayload.competition.cancels, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			let path = `${v.builder}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(
					store,
					path,
					{
						sales: 0,
						cancels: 0,
						closings: 0,
					},
					Object
				)
			}
			store[v.builder][v.lot_type].cancels++
		})
		_.forEach(this.props.payload.salespersonPayload.competition.closings, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			let path = `${v.builder}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(
					store,
					path,
					{
						sales: 0,
						cancels: 0,
						closings: 0,
					},
					Object
				)
			}
			store[v.builder][v.lot_type].closings++
		})

		_.forEach(store, (r, b) => {
			let builder = _.find(this.props.payload.public.builders, { id: parseInt(b) })
			if (!builder) return
			_.forEach(r, (v, type) => {
				let lot_type = _.find(this.props.payload.public.lot_types, { id: parseInt(type) })
				if (!lot_type) return
				ret.push({
					builder: builder && builder.name,
					lot_type: lot_type && lot_type.name,
					sales: v.sales,
					cancels: v.cancels,
					closings: v.closings,
				})
			})
		})

		ret = _.sortBy(ret, "builder") //.reverse()

		return ret
	}

	realtors = () => {
		var [labels, soldArray, closedArray] = [[], [], []]
		var ret = {}
		let model = {
			sales: 0,
			closed: 0,
			total: 0,
		}
		// First sales
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (v.bustout_date) return
			if (v.realtor_involved == 0 || !v.realtor_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_name}`)) {
				ret[`${v.realtor_name}`] = _.cloneDeep(model)
			}
			ret[`${v.realtor_name}`].sales++
		})
		// Next closings
		_.forEach(this.props.payload.salespersonPayload.competition.closings, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (v.realtor_involved == 0 || !v.realtor_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_name}`)) {
				ret[`${v.realtor_name}`] = _.cloneDeep(model)
			}
			ret[`${v.realtor_name}`].closed++
		})

		// add em up
		_.forEach(ret, (v, k) => {
			ret[k].total = v.sales + v.closed
		})

		// Compile data
		var d = []
		_.forEach(ret, (v, k) => {
			var sales = v.sales || 0
			var closed = v.closed || 0
			d.push({
				label: k,
				sold: sales,
				closed: closed,
				total: sales + closed,
			})
		})
		d = _.orderBy(d, ["total", "closed"], ["desc", "desc"]).slice(0, limit)
		_.forEach(d, (v) => {
			labels.push(v.label)
			soldArray.push(v.sold)
			closedArray.push(v.closed)
		})
		let series = [
			{
				name: "Sold",
				data: soldArray,
			},
			{
				name: "Closed",
				data: closedArray,
			},
		]

		let options = {
			plotOptions: {
				bar: {
					horizontal: true,
				},
			},
		}

		return <GroupedBar series={series} categories={labels} options={options} />
	}

	realtorOffices = () => {
		var [labels, soldArray, closedArray] = [[], [], []]
		var ret = {}
		let model = {
			sales: 0,
			closed: 0,
			total: 0,
		}
		// First sales
		_.forEach(this.props.payload.salespersonPayload.competition.sales, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (v.bustout_date) return
			if (v.realtor_involved == 0 || !v.realtor_office_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_office_name}`)) {
				ret[`${v.realtor_office_name}`] = _.cloneDeep(model)
			}
			ret[`${v.realtor_office_name}`].sales++
		})
		// Next closings
		_.forEach(this.props.payload.salespersonPayload.competition.closings, (v) => {
			if (!this.props.activeProperties.includes(v.property)) return
			if (!v.realtor_office_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_office_name}`)) {
				ret[`${v.realtor_office_name}`] = _.cloneDeep(model)
			}
			ret[`${v.realtor_office_name}`].closed++
		})

		// add em up
		_.forEach(ret, (v, k) => {
			ret[k].total = v.sales + v.closed
		})

		// Compile data
		var d = []
		_.forEach(ret, (v, k) => {
			var sales = v.sales || 0
			var closed = v.closed || 0
			d.push({
				label: k,
				sold: sales,
				closed: closed,
				total: sales + closed,
			})
		})
		d = _.orderBy(d, ["total", "closed"], ["desc", "desc"]).slice(0, limit)

		_.forEach(d, (v) => {
			labels.push(v.label)
			soldArray.push(v.sold)
			closedArray.push(v.closed)
		})
		let series = [
			{
				name: "Sold",
				data: soldArray,
			},
			{
				name: "Closed",
				data: closedArray,
			},
		]

		let options = {
			plotOptions: {
				bar: {
					horizontal: true,
				},
			},
		}

		return <GroupedBar series={series} categories={labels} options={options} />
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<>
					<div className="imageGroup">
						<Title title="Competition Report" />
						<div className="statBox">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<ImageExport name="BuilderSales" />
									<h3 className="statBox__title">Net Builder Sales</h3>
									{this.builderSales()}
								</div>
								<div className="statBox__box">
									<ImageExport name="SalesBySalespeople" />
									<h3 className="statBox__title">
										Sales by Salespeople - Net
										<span className="subhead">Top 20</span>
									</h3>
									{this.salesBySalespeople()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<ImageExport name="RealtorOffices" />
									<h3 className="statBox__title">Top {limit} Performing Realtor Offices</h3>
									{this.realtorOffices()}
								</div>
								<div className="statBox__box">
									<ImageExport name="Realtors" />
									<h3 className="statBox__title">Top {limit} Performing Realtors</h3>
									{this.realtors()}
								</div>
							</div>
						</div>
						<div className="statBox">
							<h3>Builder Activity</h3>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns.builderActivity}
								name="entry__competition"
								title="Competition"
								pageSize={20}
							/>
						</div>
					</div>
				</>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		trafficSources: state.trafficSources,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Competition))
